var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinButton2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_826_14310)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 63.5,
    r: 52.5,
    fill: "url(#paint0_radial_826_14310)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 63.5,
    r: 52.5,
    fill: "url(#paint1_radial_826_14310)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5204,
    cy: 62.8159,
    r: 45.5219,
    transform: "rotate(-150 63.5204 62.8159)",
    fill: "url(#paint2_radial_826_14310)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5204,
    cy: 62.8159,
    r: 45.5219,
    transform: "rotate(-150 63.5204 62.8159)",
    fill: "url(#paint3_radial_826_14310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.007 52.7305V55.2109H43.2492V60.9141H40.1437V55.2109H33.5227V52.7305H50.007ZM35.3391 51.1094V43.6875H48.1516V51.1094H35.3391ZM38.4055 48.668H45.0266V46.1484H38.4055V48.668ZM66.1117 56.5391V59.0781H49.6078V56.5391H53.5727V54.1953H51.4047V47.8086H61.2289V46.4414H51.3852V43.9414H64.3344V50.2695H54.5492V51.6758H64.7445V54.1953H62.3812V56.5391H66.1117ZM56.6195 56.5391H59.2953V54.1953H56.6195V56.5391ZM66.2398 59V56.3242L71.4937 51.9102C72.568 51.002 73.2223 50.3379 73.232 49.3125C73.2223 48.209 72.441 47.5352 71.357 47.5352C70.2633 47.5352 69.5113 48.2285 69.5211 49.4297H65.9859C65.9762 46.4805 68.1051 44.6641 71.357 44.6641C74.7066 44.6641 76.8453 46.3926 76.8453 49C76.8453 50.6406 76.0348 52.0176 72.8414 54.7031L71.4156 55.9336V56.0117H77.0016V59H66.2398ZM92.4031 42.8672V60.9336H89.2977V42.8672H92.4031ZM77.0711 55.6602C78.3406 55.6602 79.7859 55.6602 81.3094 55.6309V54.3613C79.4637 53.9414 78.2625 52.7109 78.2625 51.1094C78.2625 49.0977 80.1668 47.6914 82.8523 47.6914C85.577 47.6914 87.5105 49.0977 87.5203 51.1094C87.5105 52.7012 86.2996 53.9316 84.4344 54.3613V55.5234C85.7918 55.4453 87.1395 55.3281 88.4383 55.1523L88.6336 57.457C84.7566 58.1602 80.6063 58.1895 77.4617 58.1797L77.0711 55.6602ZM77.4227 47.1836V44.7617H81.3094V43.0039H84.4539V44.7617H88.3211V47.1836H77.4227ZM81.2508 51.1094C81.2508 51.8613 81.9246 52.1836 82.8523 52.1836C83.8582 52.1836 84.5125 51.8613 84.5125 51.1094C84.5125 50.3867 83.8582 50.0547 82.8523 50.0352C81.9246 50.0547 81.2508 50.3867 81.2508 51.1094ZM53.7332 70.6367V73.0586H48.9871V73.8984H55.6668V76.3398H39.1824V73.8984H45.823V73.0586H41.1551V67.4141H53.616V69.8945H44.2605V70.6367H53.7332ZM41.0184 84.8555V79.7773H50.6277V79.2109H41.0379V76.9453H53.7137V81.9062H44.0848V82.5117H54.1434V84.8555H41.0184ZM70.541 66.8672V84.9922H67.416V66.8672H70.541ZM56.1855 80.8516V73.1562H61.6738V70.793H56.1855V68.293H64.877V75.5977H59.4277V78.3027C62.0059 78.2734 64.125 78.1172 66.4199 77.7266L66.6738 80.2461C63.9395 80.7637 61.3027 80.8613 57.8848 80.8516H56.1855ZM86.6848 66.8672V84.9336H83.5012V66.8672H86.6848ZM71.3137 79.5625C75.8156 77.4238 77.6223 74.9434 78.0324 71.1641H72.3488V68.7227H81.216C81.2258 74.377 79.6242 78.8984 72.9152 82.0234L71.3137 79.5625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_826_14310",
    x: -4,
    y: 0,
    width: 135.04,
    height: 135.04,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_826_14310"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_826_14310",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_826_14310",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.395 11) rotate(134.696) scale(147.71 9053.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484416,
    stopColor: "#D23760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23755"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_826_14310",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.395 11) rotate(134.696) scale(147.71 9053.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484416,
    stopColor: "#D23760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23755"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_826_14310",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.518 17.2939) rotate(134.696) scale(128.077 7850.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484416,
    stopColor: "#D23760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23755"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_826_14310",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.518 17.2939) rotate(134.696) scale(128.077 7850.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484416,
    stopColor: "#D23760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23755"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinButton2);
export default __webpack_public_path__ + "static/media/spin-button2.c2c1fed94df019dda1722f8ba2e6b924.svg";
export { ForwardRef as ReactComponent };